import React from 'react'
import { prepareForParse, parseHtmlToReact } from '../../utils'

function CustomYouTubePlayer({
  data,
  entry: { body } = {},
  // Component props
  // コンポーネント内最上位の要素に付与する className
  className = 'movie',
  playerContainerClassName = 'movie-player-container',
  title = 'YouTube video player',
  videoId = '',
  videoOptions = {
    rel: 0,
    autoplay: 1,
  },
}) {
  const { htmlBody } = prepareForParse({
    template: { body },
    data,
  })

  const [isOpen, setIsOpen] = React.useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = (e) => {
    e.preventDefault()
    toggle()
  }

  const optionParams = new URLSearchParams(videoOptions).toString()

  return (
    <div className={className}>
      <a
        href={`https://www.youtube.com/watch?v=${videoId}&${optionParams}`}
        onClick={handleClick}
      >
        {parseHtmlToReact(htmlBody, data)}
      </a>
      {isOpen && (
        <div className={playerContainerClassName} onClick={toggle}>
          <button title="Close">x</button>
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}?${optionParams}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      )}
    </div>
  )
}

export { CustomYouTubePlayer }
